import {
  getRejectionFieldLabel,
  getRejectionStepLabel,
  parseRejectionReason,
} from "../../services/webServices/sepehr/authorization-credentials/rejection-reason";

interface RejectionReasonDisplayProps {
  rejectionReason: unknown;
}

export default function RejectionReasonDisplay({
  rejectionReason,
}: RejectionReasonDisplayProps) {
  const payload = parseRejectionReason(rejectionReason);

  if (!payload?.errors.length) {
    if (typeof rejectionReason === "string" && rejectionReason.trim()) {
      return (
        <p className="mt-1 text-sm font-medium text-red-800">{rejectionReason}</p>
      );
    }

    return null;
  }

  return (
    <div className="mt-2 space-y-3">
      {payload.errors.map((stepError) => (
        <div
          key={stepError.step}
          className="rounded-lg border border-red-100 bg-white/70 p-3"
        >
          <p className="mb-2 text-xs font-semibold text-red-700">
            {getRejectionStepLabel(stepError.step)}
          </p>
          <div className="space-y-2">
            {stepError.fields.map((fieldError, index) => {
              const fieldKey = Object.keys(fieldError)[0];
              const reason = fieldError[fieldKey];

              if (!fieldKey) return null;

              return (
                <div
                  key={`${stepError.step}-${fieldKey}-${index}`}
                  className="rounded-md bg-red-50 px-3 py-2"
                >
                  <p className="text-xs font-medium text-red-600">
                    {getRejectionFieldLabel(fieldKey)}
                  </p>
                  <p className="mt-1 text-sm text-red-800">{reason}</p>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
